module.exports = __webpack_public_path__ + "static/media/y3.12355df1.png";